import React from "react";

const SectionStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 11.4405L17.25 4.55952C17.25 4.11244 16.8332 3.75 16.319 3.75L4.68103 3.75C4.16682 3.75 3.75 4.11244 3.75 4.55952L3.75 11.4405C3.75 11.8876 4.16682 12.25 4.68103 12.25L16.319 12.25C16.8332 12.25 17.25 11.8876 17.25 11.4405Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 14.75L17.25 15.25C17.25 15.8023 16.8332 16.25 16.319 16.25L4.68103 16.25C4.16682 16.25 3.75 15.8023 3.75 15.25L3.75 14.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SectionStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;